import BaseFactory from 'services/sports/default/base-factory';
import UserAdjustmentsValidatorBuilder from './user-adjustments-validator-builder';
import EditedLineupValidatorClassicBuilder from './edited-lineup-validator-classic-builder';

export class UserAdjustmentsValidatorFactory extends BaseFactory {
    createObj(objectName, params) {
        return new UserAdjustmentsValidatorBuilder(params);
    }
}

export class EditedLineupValidatorFactory extends BaseFactory {
    createObj(objectName, params) {
        return new EditedLineupValidatorClassicBuilder(params);
    }
}
